import { nil, getBaseURL, multiNil } from "@/common";

const intersectionObserverPolyfill = require("intersection-observer");
import "@fortawesome/fontawesome-free/css/all.min.css";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router, { generateRoutes } from "./routing/router";
import store from "./store";
import "./registerServiceWorker";
import VueObserveVisibility from "vue-observe-visibility";
import VueWaypoint from "vue-waypoint";
import VueLazyload from "vue-lazyload";
import VueExtension from "./vue-extension";

Vue.config.productionTip = false;
Vue.config.devtools = document.location.hostname === "localhost";
Vue.use(VueObserveVisibility);
Vue.use(VueWaypoint);
Vue.use(VueLazyload);
(window as any).nil = nil;
(window as any).multiNil = multiNil;

store
  .dispatch("auth/authenticate")
  .catch(() => {})
  .then(() => {
    VueExtension(Vue);
    /* tslint:disable */
    generateRoutes()
      .then()
      .catch()
      .then(() => {
        const x = new Vue({
          router,
          store,
          render: h => h(App)
        }).$mount("#app");
      });
    /* tslint:enable */
  });
